import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import VendorReturn from '~/_shared/models/VendorReturn'

export const state = {
  list: [],
  vendorReturn: VendorReturn,
  vendorItems: [],
  pdf: undefined
}

export const getters = {
  list: state => state.list,
  vendorReturn: state => state.vendorReturn,
  vendorItems: state => state.vendorItems,
  pdf: state => state.pdf
}

export const mutations = {
  LIST (state, data) {
    state.list = data
  },

  VENDOR_RETURN (state, data) {
    state.vendorReturn = data
  },

  VENDOR_ITEMS (state, data) {
    state.vendorItems = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

export const actions = {
  async fetchByFilters ({ commit }, filterData) {
    await axios.get(laroute.route('vendor_return_filter', { companyAbbr: store.getters['auth/company'], ...filterData }))
      .then(response => {
        commit('LIST', response.data.data)
      })
  },

  async create ({ commit }, formData) {
    await axios.post(laroute.route('vendor_return_create', { companyAbbr: store.getters['auth/company'] }), { ...formData })
      .then(res => {
        if (res.status === 200) {
          commit('VENDOR_RETURN', res.data.data)
        }
      })
  },

  async getOne ({ commit }, id) {
    await axios.get(laroute.route('vendor_return_get_one', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        commit('VENDOR_RETURN', res.data.data)
      })
  },

  async getItems ({ commit }, id) {
    await axios.get(laroute.route('get_vendor_return_items', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        commit('VENDOR_ITEMS', res.data.data)
      })
  },

  async deleteItem ({ commit }, itemId) {
    await axios.delete(laroute.route('vendor_return_delete_item', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async update ({ commit }, { id, vendorReturn, vendorReturnItems }) {
    await axios.patch(laroute.route('vendor_return_update', { id }), { vendorReturn, vendorReturnItems })
  },

  async addItems ({ commit }, { id, items }) {
    await axios.post(laroute.route('vendor_return_add_items', { id }), { items })
  },

  async generatePdf ({ commit }, { id }) {
    const { data } = await axios.post(laroute.route('vendor_return_pdf', { companyAbbr: store.getters['auth/company'], id: id }), {}, { responseType: 'arraybuffer' })
    commit('PDF', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/vendorReturn.js